import {PropsWithChildren} from "react";
import {Box, SxProps} from "@mui/material";

export interface Props extends PropsWithChildren {
    sx?: SxProps;
}

export const Frame: React.FC<Props> = ({children, sx}) => (
    <Box
        border={1}
        borderRadius={1}
        sx={{
            borderColor: "secondary.main",
            padding: "1.125rem",
            ...sx,
        }}
    >
        {children}
    </Box>
);
